import './ProductList.scss';
import Component from './ProductList.js';
export default Component;
